import React from "react";
import { Box } from "grommet";
import { VscEye, VscEyeClosed } from "react-icons/vsc";

const CanvasToggle = ({ canvas, setCanvas }) => {
  const toggleCanvas = () => {
    setCanvas(!canvas);
  };

  return (
    <Box
      direction="row"
      align="center"
      gap="small"
      onClick={toggleCanvas}
      style={{ cursor: "pointer" }}
      focusIndicator={false}
    >
      {canvas ? <VscEye size={24} /> : <VscEyeClosed size={24} />}
    </Box>
  );
};

export default CanvasToggle;
